import React, { useState } from "react";

/**
 * CreatePostForm — card with form to create a new appointment.
 *
 * Props:
 *   onCreatePost(postData) — async callback that creates the post and returns the new post object
 */
function CreatePostForm({ onCreatePost }) {
  const [header, setHeader] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onCreatePost({ header, description, date, time, visible: true });
    setHeader("");
    setDescription("");
    setDate("");
    setTime("");
  };

  return (
    <div className="card mb-4 shadow">
      <div className="card-body">
        <h4 className="card-title mb-3">Lag ny hendelse</h4>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="cp-header" className="form-label">Overskrift</label>
            <input
              id="cp-header"
              className="form-control"
              placeholder="Overskrift"
              value={header}
              onChange={(e) => setHeader(e.target.value)}
              autoComplete="off"
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="cp-desc" className="form-label">Beskrivelse</label>
            <textarea
              id="cp-desc"
              className="form-control"
              placeholder="Beskrivelse"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="cp-date" className="form-label">Dato</label>
              <input
                id="cp-date"
                type="date"
                className="form-control"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="col">
              <label htmlFor="cp-time" className="form-label">Tid</label>
              <input
                id="cp-time"
                type="time"
                className="form-control"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Legg til konsultasjon
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreatePostForm;
